import { strings } from '@/content/strings';
import { Frame } from './Frame';
import { Surface } from './Surface';
import styles from './SelfCheckCard.module.css';

interface SelfCheckCardProps {
  options: readonly [string, string];
  onAnswer: (word: string) => void;
  /** The question (the self-check's by default). */
  title?: string;
  /**
   * The answers can be tapped: only once the child has heard what they judge. Until then the card
   * says "Listen…", so nobody taps before listening.
   */
  answerable?: boolean;
  /** Puts the question away without answering (a small link, not the way forward). */
  onSkip?: () => void;
}

/**
 * A question in the practice (coaching-framework.md principle 3), in place of the word card: the
 * child taps the word their attempt sounded like. Two words, no right-or-wrong
 * styling; the helper answers with what it heard, and practice goes on after the answer.
 */
export function SelfCheckCard({
  options,
  onAnswer,
  title = strings.speech.selfCheck,
  answerable = true,
  onSkip,
}: SelfCheckCardProps) {
  return (
    <Frame className={styles.frame}>
      <Surface variant="glassPanel" className={styles.panel}>
        <p className={styles.title}>{title}</p>
        {answerable ? (
          <div className={styles.options}>
            {options.map((word) => (
              <button
                key={word}
                type="button"
                className={styles.option}
                onClick={() => {
                  onAnswer(word);
                }}
              >
                {word}
              </button>
            ))}
          </div>
        ) : (
          <div className={styles.listening} role="status">
            <span className={styles.wave} aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
            </span>
            {strings.speech.listenFirst}
          </div>
        )}
        {onSkip && answerable && (
          <button type="button" className={styles.skip} onClick={onSkip}>
            {strings.speech.skipQuestion}
          </button>
        )}
      </Surface>
    </Frame>
  );
}
